import { useCodeLabels } from '../lib/catalogs'
import { materialKind, MATERIAL_ORE, MATERIAL_WASTE, MATERIAL_UNKNOWN } from '../lib/holes'

// Estéril (waste) em âmbar, minério (ore) em teal, desconhecido em neutro.
export const MATERIAL_CHIP_CLS = {
  [MATERIAL_ORE]: { box: 'bg-brand-50 text-brand-700 dark:bg-brand-500/15 dark:text-brand-300', dot: 'bg-brand' },
  [MATERIAL_WASTE]: { box: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300', dot: 'bg-amber-500' },
  [MATERIAL_UNKNOWN]: { box: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300', dot: 'bg-slate-400' },
}

const asText = (v) => (typeof v === 'string' || typeof v === 'number' ? String(v).trim() : '')

// Material de um ciclo ou furo. No 0.8 chega em códigos (tipo, classificação, teor) e o
// chip mostra o que vier, traduzido pelo catálogo da mina ou pela i18n local; no 0.7 é o
// texto livre que o device mandou, sem tradução.
export default function MaterialChip({ type, classification, grading, material }) {
  const labels = useCodeLabels()
  const typeCode = asText(type)
  const text = typeCode
    ? [
        labels.materialType(typeCode),
        asText(classification) && labels.classification(asText(classification), typeCode),
        asText(grading) && labels.grading(asText(grading), typeCode),
      ].filter(Boolean).join(' · ')
    : asText(material)
  if (!text) return null
  const cls = MATERIAL_CHIP_CLS[materialKind(typeCode, asText(material))] || MATERIAL_CHIP_CLS[MATERIAL_UNKNOWN]
  return (
    <span title={text} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium min-w-0 ${cls.box}`}>
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${cls.dot}`} />
      <span className="truncate">{text}</span>
    </span>
  )
}
